import { useCallback, useState } from 'react';
import { Code, getCode } from 'api/codeApi';
import { useLoginContext } from 'components/providers/loginContext';

export function useCode(): [
  (redirectUri: string) => Promise<Code | undefined>,
  string,
  boolean,
  any,
] {
  const loginContext = useLoginContext();
  const [query, setQuery] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(undefined);

  // リソースオーナーの認可要求に必要なコードを取得する
  const handleGetCode = useCallback(
    async (redirectUri: string): Promise<Code | undefined> => {
      try {
        if (loading) return;
        setLoading(true);

        // コードを取得する
        const code = await getCode(loginContext, redirectUri);

        // queryをデコード
        setQuery(base64Decode(code.query));

        setLoading(false);
        setError(undefined);
      } catch (e) {
        setError(e);
        setLoading(false);
      }
    },
    [loading, loginContext],
  );

  return [handleGetCode, query, loading, error];
}

// Base64の文字列をデコードする
function base64Decode(str: string) {
  return window.atob(str);
}
